import { Navbar, Carousel, Minter, About, Roadmap, Team, FAQ } from './containers';


export default function App() {
  return (
    <>
       <Navbar/>
       <Carousel/>
       <Minter />
       <About />
       <Roadmap />
       <Team />
       <FAQ />
    </>
  );
}


